import React from "react";

const NegativeChageIcon = ({ ...props }) => {
  return (
    <svg width={9} height={4} viewBox="0 0 9 4" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18 0L4.484 4 .786 0"
        fill="#F66"
      />
    </svg>
  );
};

export default NegativeChageIcon;
